'use strict';
AOS.init();
var swiper = new Swiper('.swiper', {
    loop: true,
    spaceBetween: 20,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        320: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 2
        }
    }
});
// lightbox логіка
var slides = document.querySelectorAll('.galery__lightbox');
var lightbox = document.getElementById('lightbox');
var lightboxImg = lightbox.querySelector('.lightbox__img');
var closeBtn = lightbox.querySelector('.lightbox__close');
var prevBtn = lightbox.querySelector('.lightbox__prev');
var nextBtn = lightbox.querySelector('.lightbox__next');
var currentIndex = 0;
slides.forEach(function(img, index) {
    img.addEventListener('click', function() {
        currentIndex = index;
        showImage();
        lightbox.classList.add('active');
    });
    img.addEventListener('click', function() {
        currentIndex = index;
        showImage();
        lightbox.classList.add('active');
        document.body.classList.add('no-scroll');
    });
});
function showImage() {
    lightboxImg.src = slides[currentIndex].src;
}
closeBtn.addEventListener('click', function() {
    lightbox.classList.remove('active');
    document.body.classList.remove('no-scroll');
});
lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
        lightbox.classList.remove('active');
        document.body.classList.remove('no-scroll');
    }
});
prevBtn.addEventListener('click', function() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showImage();
});
nextBtn.addEventListener('click', function() {
    currentIndex = (currentIndex + 1) % slides.length;
    showImage();
});
// очистка форми
var form = document.querySelector('#form');
form.addEventListener('submit', buttonClick, false);
function buttonClick(event) {
    event.preventDefault();
    form.reset();
}
// анімація меню
var menu = document.getElementById('menu');
function openMenu() {
    menu.classList.remove('closing');
    menu.classList.add('active');
}
function closeMenu() {
    menu.classList.remove('active');
    menu.classList.add('closing');
    var onEnd = function(e) {
        if (e.target === menu && e.propertyName === 'opacity') {
            menu.classList.remove('closing');
            menu.removeEventListener('transitionend', onEnd);
        }
    };
    menu.addEventListener('transitionend', onEnd);
}
window.addEventListener('hashchange', function() {
    if (location.hash === '#menu') openMenu();
    else if (menu.classList.contains('active')) closeMenu();
});
if (location.hash === '#menu') openMenu();

//# sourceMappingURL=Museum.03807fa5.js.map
